import Clock from '../icons/Clock'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { FETCH_LESSON } from '../redux/lessonReducer'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { CLEAR_LESSON } from '../redux/lessonReducer'

type Props = {}

const LessonClock = (props: Props) => {
  const [state, setState] = useState(0)
  const { lessonId } = useParams()
  const [animation, setAnimation] = useState(false)
  const navigate = useNavigate()
  const lessonEndTimeStamp = useSelector((state: RootReducer) => {
    const lesson = state.lessonReducer.lesson
    if (lesson) {
      return lesson.starts_at * 1000 + lesson.duration * 60000
    }
    return 30 * 1000 * 60 * 1000 * 1000
  })
  const dispatch = useDispatch()

  useEffect(() => {
    if (lessonId) {
      dispatch(FETCH_LESSON({ id: lessonId }))
    }
    return () => {
      dispatch(CLEAR_LESSON())
    }
  }, [lessonId, dispatch])

  useEffect(() => {
    const interval = setInterval(() => {
      setState((prev) => prev + 1)
    }, 500)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const now = new Date().getTime()
    const timeLeft = lessonEndTimeStamp - now
    if (timeLeft < 30 * 1000) {
      setAnimation(true)
    }
    if (timeLeft < 0) {
      navigate('/lesson-finished')
    }
  }, [state, navigate, lessonEndTimeStamp])

  const now = new Date().getTime()
  const timeLeft = lessonEndTimeStamp - now
  const minutes = String(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0')
  const seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(2, '0')
  return (
    <>
      <div className={`flex text-white items-center text-18 ${animation ? 'clock' : ''}`}>
        <div className="w-[2.5rem] h-[2.5rem] text-white">
          <Clock />
        </div>
        <div className="w-1" />
        <div>{`${minutes}:${seconds}`}</div>
      </div>
      <style>{`
        .clock {
          animation: pulse 1s infinite;
        }
        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
      `}</style>
    </>
  )
}

export default LessonClock
